import { graphql } from 'react-relay';
export const CompanyHubSpaceQuery = graphql`
	query CompanyHubSpaceQuery($key: String!) {
		space(key: $key) {
			id
			homepageId
		}
	}
`;
